import { render, staticRenderFns } from "./Table-ClienteFornecedor.vue?vue&type=template&id=d28fa71c&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Table-ClienteFornecedor.vue"
export default component.exports